export const DEVICE_IDENTIFIER = 'DEVICE_IDENTIFIER'